import {setBattleValue} from '../../redux-actions/battle-actions.js'
import store from '../../init/store.js'
import {handleSeenRollout} from '../lifecycle/handle-seen-rollout.js'
import {convertSpeechArrayToTextLineArray} from '../../text/convert-speech-array-to-textLine-array.js'
import {getAnimation} from '../ArenaView/animation-components/getAnimation.js'
import {handleStateChange} from './handle-state-change'
/** Receive a new rollout. Put it in state and update the log. */


export function handleNewRollout(rollout) {

  if (!rollout.submitterCombatantId) {
    console.warn('no submitter', rollout)
  }

    setBattleValue({
        rolloutId: rollout.rolloutId,
        rolloutData: rollout.rolloutPayload, //This is the array of Rollout Step models
        rolloutExecutingIndex: 0, //this property is only used by `handleRolloutStep`

        //Multiplayer specific: clear out the battle taunt
        arenaTaunt: null,

      //   //Record the person that submitted this (so we can visualize)
      // seriesTurnsSubmitters: [
      //   ...store.getState().battle.seriesTurnsSubmitters,
      //   rollout.submitterCombatantId
      // ],
      //NOTE: Moved this to the END of the rollout ("handle-seen-rollout"). Keeping this here until that change is baked in my brain.

        //Save a copy at the top of `history`
        rolloutHistory: [
            {
                //Only save the properties we care about. (not `seenBy` or `submittedBy`)
                submitterCombatantId:rollout.submitterCombatantId,
                rolloutId: rollout.rolloutId,
                rolloutPayload: rollout.rolloutPayload,
                timestamp: rollout.timestamp
            },
            ...store.getState().battle.rolloutHistory
        ],

      arenaIsRolloutShowing: true, //Toggle ON visibility of the rollout message area
    });


  //Handle the first step:
  handleRolloutStep();
}

//Used by "handleNewRollout" and Arena's "RolloutMessageBox" (for message done callbacks)
export function handleRolloutStep() {

    //Get the current rollout array, and the current index. (rolloutExecutingIndex)
    const {rolloutExecutingIndex, rolloutData} = store.getState().battle;
    const currentStep = rolloutData[rolloutExecutingIndex];

    // Does this blip node exist (haven't made it through the array yet)
    if (!currentStep) {
        //We are done with this rollout. Call the "seen" step.
        handleSeenRollout(); //TODO: May need to move around the ConsoleView implementation of this fn because of this call?
        return;
    }

  //TODO: Ran into a problem where messages were starting on 1 because of the "always uptick".
  //Now upticking right before recalling

  //---------------------
  //CASE 1: Message is showing. We wait for the View Layer to call this function again.
  if (currentStep.type === "message") {

      //Get the player's team so we can populate it in our data object
      const playerId = store.getState().battle.battlePlayerId[0];
      const playerModel = store.getState().battle.combatants[playerId];
      const playerTeam = playerModel ? playerModel.belongsToTeam : "reporting";

      //set the last known message!
      //We don't want the views to compute the text to say, because index is always changing. (need to keep the text up through animations and such)
      //Let's explicitly remember the text line we want on screen.
      setBattleValue({
        lastSeenTextMessage: {
          key: String( Date.now() ), //Provide a key so we can force remounts through keys
          content: convertSpeechArrayToTextLineArray(currentStep.content, {
            playerTeamId: playerTeam,
            defaultTextColor: "#fff" //Sort of a weird mixed concern here. This sets the color of battle text. Seems weird to define style here
          })
        }
      });

    //if arena mode, wait for the View Layer to call `handleRolloutStep` again
    //otherwise, this can be called again right away (Console and Reporting modes)
    if (store.getState().battle.battleViewMode !== "arena") {
      //console.log('auto calling for non-arena mode');
      //console.warn('note to dev: end of battle is still calling "seen" directly. Need to adjust.')

      //Uptick the executingIndex (for the View Layer, because we don't have a View Layer in these modes)
      setBattleValue({
        rolloutExecutingIndex: rolloutExecutingIndex + 1
      });

      //Note: both Console and Reporting view automatically hit PLAY
      //Console View: bit of a delay
      //Reporting View: automatic (ms = 0)
      const timeoutMs = store.getState().battle.battleViewMode === "console" ? 500 : 0;
      setTimeout(() => {
        handleRolloutStep();
      }, timeoutMs); //This takes the place of the old waiting Rollout Button thing
    }
  }

  //CASE 2: gradually increment state changes -> This allows us to play with lifebar animation and "getting attacked" post-animation stuff
  if (currentStep.type === "stateChange") {
      handleStateChange(currentStep);
  }


  //CASE 3: cloudQueue changes are executed right now, then call for the next step
  if (currentStep.type === "cloudQueue") {
    // console.log('handle cloudQueue');
    setBattleValue({
      cloudQueue: currentStep.payload || [] //latest version of payload
    });

    setBattleValue({
      rolloutExecutingIndex: rolloutExecutingIndex + 1
    });
    handleRolloutStep(); //move on to the next step
  }

  //CASE 4: Animations
  //setBattleValue `arenaAnimationComponent` to an animation component so it mounts
  if (currentStep.type === "animation") {

      if (store.getState().battle.battleViewMode === "arena") {
        setBattleValue({
          arenaAnimationComponent: getAnimation(
            currentStep.animationKey,
            currentStep.animationData
          )
        })
      } else {
        //Just move on if this is Console or Reporting
        setBattleValue({ rolloutExecutingIndex: rolloutExecutingIndex + 1 });
        handleRolloutStep(); //move on to the next step
      }
    //TODO: What if state change was bundled with the animation somehow?
    //  -> Would love to have more control over the timeline of state/animation changes

  }

}



// WEBPACK FOOTER //
// ./src/battle/lifecycle/handle-new-rollout.js